import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/americanFootballCard.css';
// helpers
import {getText} from '../../../../../helpers/localization';
import ImageLoader from 'react-load-image';
import {ASSETS_URL} from '../../../../../constants/endpoints';
import {getGameFromChannel} from "../../../helpers/gameHelpers";

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events
    };
};

class SelectedAmericanFootballCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events
        };
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        let showActive = this.props.showActive;
        let activeEvent = storeData.vpp.events[0];

        let teamOne = showActive == true ? activeEvent.teamOne.split(' ').join('').toUpperCase() : selectedEvent.teamOne.split(' ').join('').toUpperCase();
        let teamTwo = showActive == true ? activeEvent.teamTwo.split(' ').join('').toUpperCase() : selectedEvent.teamTwo.split(' ').join('').toUpperCase();
        let showTeamName = showActive == true ? `${style.gameTitleBanner} ${style.gameTitleBannerMobile}` : style.gameTitleBanner;
        let titleBanner = showActive == true ? style.gameTitleBannerTop : style.gameTitleBannerBottom;
        return (
            <div id={'af_card'} className={`${titleBanner}`}>
                <div className={style.teamNameImage}>
                    <div className={style.imageLoader}>
                        <ImageLoader
                            src={`${ASSETS_URL}${getGameFromChannel(showActive == true ? activeEvent.channel : selectedEvent.channel, storeData.vpp.games).assetsPath}/silks/bannerIcon/${teamTwo}_Kit_Icon_Away_Full.png`}>
                            <img
                                src={`${ASSETS_URL}${getGameFromChannel(showActive == true ? activeEvent.channel : selectedEvent.channel, storeData.vpp.games).assetsPath}/silks/bannerIcon/${teamTwo}_Kit_Icon_Away_Full.png`}
                                className={style.footballIcon}
                                alt={`icon_${showActive == true ? activeEvent.teamTwo : selectedEvent.teamTwo}`}/>
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.footballIcon}
                                 alt={`loading`}/>
                        </ImageLoader>
                    </div>
                    <div
                        className={`${showTeamName}`}>{`${getText(showActive === true ? activeEvent.teamTwo : selectedEvent.teamTwo, this.props.store)}`}</div>
                </div>
                <div className={style.versus}>{getText('AT', this.props.store)}</div>
                <div className={style.teamNameImage}>
                    <div
                        className={`${showTeamName}`}>{`${getText(showActive === true ? activeEvent.teamOne : selectedEvent.teamOne, this.props.store)}`}</div>

                    <div className={style.imageLoader}>
                        <ImageLoader
                            src={`${ASSETS_URL}${getGameFromChannel(showActive == true ? activeEvent.channel : selectedEvent.channel, storeData.vpp.games).assetsPath}/silks/bannerIcon/${teamOne}_Kit_Icon_Full.png`}>
                            <img
                                src={`${ASSETS_URL}${getGameFromChannel(showActive == true ? activeEvent.channel : selectedEvent.channel, storeData.vpp.games).assetsPath}/silks/bannerIcon/${teamOne}_Kit_Icon_Full.png`}
                                className={style.footballIcon}
                                alt={`icon_${showActive == true ? activeEvent.teamOne : selectedEvent.teamOne}`}/>
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.footballIcon}
                                 alt={`loading`}/>
                        </ImageLoader>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(SelectedAmericanFootballCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/americanFootball/containers/selectedAmericanFootballCard.js